import tinymce from 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/autolink/plugin'
import 'tinymce/plugins/advlist/plugin'
import 'tinymce/plugins/print/plugin'
import 'tinymce/plugins/print/plugin'
import 'tinymce/plugins/lists/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/image/plugin'
import 'tinymce/plugins/charmap/plugin'
import 'tinymce/plugins/preview/plugin'
import 'tinymce/plugins/pagebreak/plugin'
import 'tinymce/plugins/searchreplace/plugin'
import 'tinymce/plugins/wordcount/plugin'
import 'tinymce/plugins/visualblocks/plugin'
import 'tinymce/plugins/visualchars/plugin'
import 'tinymce/plugins/anchor/plugin'
import 'tinymce/plugins/hr/plugin'
import 'tinymce/plugins/insertdatetime/plugin'
import 'tinymce/plugins/nonbreaking/plugin'
import 'tinymce/plugins/fullscreen/plugin'
import 'tinymce/plugins/table/plugin'
import 'tinymce/plugins/code/plugin'
import 'tinymce/plugins/emoticons/plugin'
import 'tinymce/plugins/template/plugin'
import 'tinymce/plugins/media/plugin'
import 'tinymce/plugins/help/plugin'
import 'tinymce/plugins/paste/plugin'
import 'tinymce/plugins/emoticons/js/emojis'


//init tinymce on all textareas
tinymce.init({
  selector:'textarea',
  width: '100%',
  height: 400,
  plugins: [
    'advlist autolink link image lists charmap print preview hr anchor pagebreak',
    'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
    'table emoticons template paste help',
  ],
  toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | ' +
      'bullist numlist outdent indent | link image | print preview media fullscreen | ' +
      'forecolor backcolor emoticons | help',
  menu: {
    favs: {title: 'My Favorites', items: 'code visualaid | searchreplace | emoticons'},
  },
  menubar: 'favs file edit view insert format tools table help',
  skin_url:'/tinymce/assets/styles',
});



// WEBPACK FOOTER //
// ./scripts/routes/admin/partials/tinymce.js